import React, { Component } from "react";
import {
  InputGroup,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { currentDate } from '../../../lib/common'
import { storedb } from '../../client/storedb'
import Pagination from "react-js-pagination";
import * as guestConstant from './constants'
import * as guestAction from './actions'
import DisplayRecordText from "../../controls/_DisplayRecordText"
import CheckboxTreeList from "../../controls/_CheckboxTreeList";
import { customSelectStyles, mapArray} from '../../../lib/common';
import Select from 'react-select';
class GuestReport extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      tong_tien: 0,
      page: 1,
      per_page: 20,
      multipleValueNVKD: [],
      treeNvkd: [],
      treeKH: [],
      listNhomKhachHang: [],
      selectedOptionNhomKhachHang: null,
      listKhachHang: [],
      selectedOptionKhachHang: null,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  viewkhachhangItem = (e, item) => {
    e.preventDefault()
    this.props.history.push('/sale-report?kh=' + item.KhachHangId + "&ql=" + item.NhanVienId);
  };
  handleChangeNhomKhachHang = selectedOptionNhomKhachHang => {
    let { selectedOptionKhachHang } = this.state
    if (selectedOptionNhomKhachHang != null) {
      if (selectedOptionNhomKhachHang.value > 0) {
        this.fetchKHByNhom([selectedOptionNhomKhachHang.value])
      }
    } else {
      selectedOptionKhachHang = null
      //load khách hàng theo nvkd
      let { multipleValueNVKD } = this.state
      if (multipleValueNVKD.length > 0) {
        this.fetchKH(multipleValueNVKD);
      }
    }
    this.setState({ selectedOptionNhomKhachHang, selectedOptionKhachHang });
  };
  handleChangeKhachHang = selectedOptionKhachHang => {
    this.setState({ selectedOptionKhachHang });
  };
  onHandleRemoveNvkd = () => {
    this.setState({ multipleValueNVKD: [], selectedOptionKhachHang: null, listKhachHang: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNVKD: multipleValue })
    if (multipleValue.length > 0) {
      this.fetchKH(multipleValue);
    } else {
      this.setState({ selectedOptionKhachHang: null, listKhachHang: [] });
    }
  }

  onHandleRemoveKH = () => {
    this.setState({ listKhachHang: [] })
  }
  fetchNhomKhachHang = () => {
    const { guestReportNhomKhRequest } = this.props
    var requestData = {
      keyword: '',
      page: 1,
      per_page: 100
    };
    return guestReportNhomKhRequest(requestData, (data) => {
      let listKH = data;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn user đó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  fetchNvkd = (quanlys) => {
    const { guestReportNvkdRequest } = this.props
    var requestData = {
      store_id: this.state.store_id,
      userIds: quanlys
    };
    return guestReportNvkdRequest(requestData);
  }
  fetchKH = (nvkds) => {
    const { guestReportKhRequest } = this.props
    var requestData = {
      stores_id: this.state.store_id,
      nvkds: nvkds
    };
    return guestReportKhRequest(requestData);
  }
  fetchKHByNhom = (nhomId) => {
    const { guestReportKhByNhomRequest } = this.props
    var requestData = {
      nvkds: this.state.multipleValueNVKD,
      nhomId: nhomId
    };
    return guestReportKhByNhomRequest(requestData, (data) => {
      let listKH = data;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn user đó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    const { guestReportListRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD,
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang),
      listKH: mapArray(this.state.selectedOptionKhachHang),
      trangThai: this.state.trangThai,
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return guestReportListRequest(requestData)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD.join(","),
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang).join(","),
      listKH: mapArray(this.state.selectedOptionKhachHang).join(","),
      trangThai: this.state.trangThai,
      keyword: this.state.keyword,
    };
    return reportExportXlsRequest(requestData, (listEXP) => {
      var dataFile = new Blob([listEXP], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportGiaoDich';
      var fileName = "baocao_giaodich.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportGiaoDich";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.guestReport.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  componentDidMount() {
    this.fetchNvkd();
    this.fetchNhomKhachHang();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.guestReport.type == guestConstant.GUEST_REPORT_NVKD_SUCCESS) {
      let { listNV } = nextProps.guestReport;
      if (listNV && listNV.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn user đó
        const NvkdChecked = listNV.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNvkd(NvkdChecked)
      };
      this.setState({
        treeNvkd: listNV
      });
    }
    else if (nextProps.guestReport.type == guestConstant.GUEST_REPORT_KH_SUCCESS) {
      let { listKH } = nextProps.guestReport;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn user đó
        //const KHChecked = listKH.map((item) => { return { value: item.Id } })
        //this.onHandleChoiceKH(KHChecked)
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    }

    else if (nextProps.guestReport.type == guestConstant.GUEST_REPORT_LIST_SUCCESS) {
      let { list, item } = nextProps.guestReport;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        tong_tien: item.tong_tien,
        list: list
      });
    } else if (nextProps.guestReport.type == guestConstant.GUEST_REPORT_NHOMKH_SUCCESS) {
      let { listNhomKh } = nextProps.guestReport;
      this.setState({
        listNhomKhachHang: listNhomKh.map((item) => { return { value: item.NhomKhId, label: item.Ten } })
      });
    }
  }
  render() {
    const {
      list,
      treeNvkd,
      selectedOptionNhomKhachHang,
      listNhomKhachHang,
      selectedOptionKhachHang,
      listKhachHang
    } = this.state
    const {
      handleSubmit,
      guestReport: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn report">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col xs="6" sm="2" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker name="tuNgay"
                      placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right"  >
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker name="denNgay" placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={treeNvkd}
                      isMultiChoice={false}
                      checked={this.state.multipleValueNVKD}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOptionNhomKhachHang}
                    onChange={this.handleChangeNhomKhachHang}
                    options={listNhomKhachHang}
                    placeholder="Nhóm khách hàng"
                    className="form-control p-0"
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isClearable={true}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOptionKhachHang}
                    onChange={this.handleChangeKhachHang}
                    options={listKhachHang}
                    placeholder="Khách hàng"
                    className="form-control p-0"
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isClearable={true}
                  />
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="w-100 mt-2 mb-2">
            <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
            <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Nhân viên KD</th>
                    <th scope="col" className="text-left">Tên khách hàng</th>
                    <th scope="col" className="text-center">Doanh thu <br /> đã CK</th>
                    <th scope="col" className="text-left">Địa chỉ</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="4" className="text-right">
                      Tổng cộng:
                     <span className="text-success">
                        {this.state.tong_tien &&
                          this.state.tong_tien.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th></th>
                  </tr>
                </tfoot>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-left"><a href='#' onClick={(e) => this.viewkhachhangItem(e, res)}>{res.TenKhachHang}</a></td>
                        <td className="text-right">{parseFloat(res.TongTien || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{res.DiaChi}</td>
                      </tr>
                    ))
                  )}
                </tbody>

              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  guestReport: state.guestReport,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  guestReportRoleRequest: guestAction.guestReportRoleRequest,
  guestReportQuanLyRequest: guestAction.guestReportQuanLyRequest,
  guestReportNvkdRequest: guestAction.guestReportNvkdRequest,
  guestReportKhRequest: guestAction.guestReportKhRequest,
  guestReportListRequest: guestAction.guestReportListRequest,
  reportExportXlsRequest: guestAction.reportExportXlsRequest,
  guestReportNhomKhRequest: guestAction.guestReportNhomKhRequest,
  guestReportKhByNhomRequest: guestAction.guestReportKhByNhomRequest
})(GuestReport)

const formed = reduxForm({
  form: 'guestReport',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/Reports/GuestReport/GuestReport.js